import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/Documents/index.tsx");
